import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DrawerModal from "./drawerModal";
import ActionButton from "../button/actionButton";

const useStyles = makeStyles((theme) => ({
  title: {
    color: '#FDFDFD',
    fontFamily: 'DM Sans',
    fontWeight: 700,
    fontSize: 32,
    lineHeight: '42px',
    letterSpacing: '-0.5px',
    marginBottom: 16,
  },
  subtitle: {
    color: theme.text.subtitle,
    opacity: 0.6,
    marginBottom: 48,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    position: 'absolute',
    bottom: 48,
    left: 32,
    right: 32,
  }
}));

const DeleteCardConfirmDrawer = ({ onClose, onConfirm }) => {
  const classes = useStyles();
  const handleConfirm = async () => {
    try {
      await onConfirm?.();
    } finally {
      onClose?.();
    }
  };
  return (
    <DrawerModal onClose={onClose}>
      <Typography className={classes.title}>Are you sure you want to delete this card?</Typography>
      <Typography className={classes.subtitle}>This action cannot be undone</Typography>
      <div className={classes.actions}>
        <ActionButton variant="primary" size="lg" onClick={handleConfirm}>Yes delete</ActionButton>
        <ActionButton variant="text" size="md" onClick={onClose}>Cancel</ActionButton>
      </div>
    </DrawerModal>
  );
}

export default DeleteCardConfirmDrawer;


